import Currency from 'components/Currency'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import WireTransfer from './Deposit/WireTransfer'

const Disclaimer = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${color('text')};
`

type Props = {
  currency: string
  flow: 'DEPOSIT' | 'WITHDRAW'
  onBack?: () => void
}
const WireInstructionsModal = ({ currency, flow, onBack }: Props) => (
  <WireTransfer currency={currency} onBack={onBack}>
    {flow === 'WITHDRAW' && (
      <Disclaimer>
        <I18n
          currency={<Currency code={currency} />}
          data={messages.link_bank_account_description}
        />
      </Disclaimer>
    )}
  </WireTransfer>
)

export default WireInstructionsModal
